<template>
  <div class="honour">
    <div class="card">
      <div class="cover">
        <img style="width:60%;" src="@/assets/images/about/honor (12).jpg" alt />
      </div>
      <h2>中国珠宝玉石首饰行业诚信示范单位</h2>
      <p>2019年12月</p>
    </div>
    <div class="card">
      <div class="cover">
        <img src="@/assets/images/about/honor (13).jpg" alt />
      </div>
      <h2>“华夏杯”玉出云南文化大奖特等奖</h2>
      <p>2019年4月</p>
    </div>
    <div class="card">
      <div class="cover">
        <img src="@/assets/images/about//honor (14).jpg" alt />
      </div>
      <h2>中国改革开放40周年珠宝行业“先进企业奖”</h2>
      <p>2018年12月12日</p>
    </div>
    <div class="card">
      <div class="cover">
        <img src="@/assets/images/about//honor (15).jpg" alt />
      </div>
      <h2>2018年云南匠心品牌</h2>
      <p>2018年5月</p>
    </div>
    <div class="card">
      <div class="cover">
        <img src="@/assets/images/about//honor (1).jpg" alt />
      </div>
      <h2>2018年云南良心企业</h2>
      <p>2018年5月</p>
    </div>
    <div class="card">
      <div class="cover">
        <img src="@/assets/images/about/honor (2).jpg" alt />
      </div>
      <h2>2016年度良心品牌</h2>
      <p>2017年1月5日</p>
    </div>
    <div class="card">
      <div class="cover">
        <img src="@/assets/images/about/honor (3).jpg" alt />
      </div>
      <h2>2015第二届云南省互联网大会云南电商价值榜</h2>
      <p>2015年10月</p>
    </div>
    <div class="card">
      <div class="cover">
        <img src="@/assets/images/about/honor (4).jpg" alt />
      </div>
      <h2>云南互联网协会授予翡翠王朝“副会长单位”</h2>
      <p>2015年1月</p>
    </div>
    <div class="card">
      <div class="cover">
        <img src="@/assets/images/about/honor (5).jpg" alt />
      </div>
      <h2>云南省珠宝玉石文化促进协会“常务副会长单位”</h2>
      <p>2014年11月至2019年11月</p>
    </div>
    <div class="card">
      <div class="cover">
        <img src="@/assets/images/about/honor (6).jpg" alt />
      </div>
      <h2>被授予“青年文明号”</h2>
      <p>2014年4月</p>
    </div>
    <div class="card">
      <div class="cover">
        <img src="@/assets/images/about/honor (7).jpg" alt />
      </div>
      <h2>云南公益事业捐赠荣誉证书</h2>
      <p>2014年12月16日</p>
    </div>
    <div class="card">
      <div class="cover">
        <img src="@/assets/images/about/honor (8).jpg" alt />
      </div>
      <h2>云南大学工商管理与旅游管理学院</h2>
      <p>2014年12月2日</p>
    </div>
    <div class="card">
      <div class="cover">
        <img src="@/assets/images/about/honor (9).jpg" alt />
      </div>
      <h2>2012年云南十佳创新网站</h2>
      <p>2013年9月</p>
    </div>
    <div class="card">
      <div class="cover">
        <img src="@/assets/images/about/honor (10).jpg" alt />
      </div>
      <h2>云南电子商务“十佳企业”</h2>
      <p>2013年9月</p>
    </div>
    <div class="card">
      <div class="cover">
        <img src="@/assets/images/about/honor (11).jpg" alt />
      </div>
      <h2>商界青年领袖提名奖</h2>
      <p>2013年</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'honour',
  components: {

  },
  data() {
    return {

    }
  },
  computed: {
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$route.query.index) {
        this.tab = this.$route.query.index;
      }
    })
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped >
.honour {
  padding: 0.2rem 0.21rem;
  .card {
    background-color: rgba(255, 255, 255, 1);
    padding: 0.27rem 0.32rem;
    margin-bottom: 0.2rem;
    h2 {
      font-size: 0.2rem;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      padding: 0.13rem 0 0.03rem 0;
    }
    p {
      font-size: 0.2rem;
      color: rgba(128, 128, 128, 1);
    }
  }
}
</style>
